export enum TipoPedido {
    Manual,
    Alije,
    Tams
}